import { useRef } from "react";
import GotoTop from "../../components/GotoTop/GotoTop.jsx";
import ShortCut from "../../components/ShortCut/ShortCut.jsx";
import { useEnhanceCodeBlocks } from "../../util/codeBlock.jsx";

const ManualViewPage = (props) => {
  const manualRef = useRef();

  const convertDateTimeFormat = (dateTimeString) => {
    if (null === dateTimeString) return "";
    const date = new Date(dateTimeString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      // hour: "numeric",
      // minute: "numeric",
      // second: "numeric",
    };
    const result = date.toLocaleString("ko-KR", options);
    return result === "Invalid Date" ? "" : result;
  };

  useEnhanceCodeBlocks(
    manualRef,
    props.pageData.content,
    props.pageData.display,
  );
  return (
    <>
      <div
        className={
          !props?.compare ? "manual-home manual-page-main" : "manual-home"
        }
      >
        <div className="manual-container">
          {props?.pageData?.updatedDttm ? (
            <span className="release-date">
              릴리스 날짜 :{" "}
              {convertDateTimeFormat(props?.pageData?.updatedDttm)}
            </span>
          ) : (
            ""
          )}
          <div className="manual-page-path">
            {props.pageData.path && props?.pageData?.display === "Y"
              ? props.pageData.path &&
                props.pageData?.path[0] + " > " + props.pageData?.path[1]
              : "."}
          </div>
          <h2 className="manual-title">
            {props.pageData.title && props?.pageData?.display === "Y"
              ? props.pageData.title
              : "매뉴얼이 존재하지 않습니다."}
          </h2>
          {props.pageData.content && props?.pageData?.display === "Y" ? (
            <div
              ref={manualRef}
              dangerouslySetInnerHTML={{ __html: props.pageData.content }}
              className="manual-page-content"
            />
          ) : (
            <div className="manual-page-content">
              <section className="manual-content">
                <h2 className="manual-content-title manual-item">
                  내용이 존재하지 않습니다.
                </h2>
              </section>
            </div>
          )}
        </div>
        {props.pageData.content && (
          <ShortCut
            data={props.pageData.content}
            manualRef={manualRef}
            hash={props?.hash}
          />
        )}
      </div>
      <GotoTop />
    </>
  );
};

export default ManualViewPage;
